module.exports = __webpack_public_path__ + "static/media/26-1.d5f8b4ea.mp3";